"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CsvContentView = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const x_data_grid_premium_1 = require("@mui/x-data-grid-premium");
const icons_material_1 = require("@mui/icons-material");
const react_hook_form_1 = require("react-hook-form");
const react_intl_1 = require("react-intl");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const CsvContentView = (props) => {
    const { columns, csvContentName, resetForm } = props;
    const csvContent = (0, react_hook_form_1.useWatch)({ name: csvContentName });
    const form = (0, react_hook_form_1.useFormContext)();
    const handleRowOrderChange = (event) => {
        const { oldIndex, targetIndex } = event;
        const newCsvContent = [...csvContent];
        const row = newCsvContent.splice(oldIndex, 1)[0];
        newCsvContent.splice(targetIndex, 0, row);
        form.setValue(csvContentName, newCsvContent, { shouldDirty: true });
    };
    const ResetButton = () => ((0, jsx_runtime_1.jsx)(ui_kit_1.Button, { intent: "secondary", startIcon: (0, jsx_runtime_1.jsx)(icons_material_1.Clear, { fontSize: "inherit" }), onClick: resetForm, "data-testid": "ResetFormButton", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "form.buttons.reset" }) }));
    return ((0, jsx_runtime_1.jsx)(material_1.Box, { sx: { height: 440 }, children: (0, jsx_runtime_1.jsx)(x_data_grid_premium_1.DataGridPremium, { columns: columns, rows: csvContent, rowReordering: true, density: "compact", onRowOrderChange: handleRowOrderChange, slots: {
                toolbar: ResetButton,
            }, disableAggregation: true, disableRowGrouping: true }) }));
};
exports.CsvContentView = CsvContentView;
//# sourceMappingURL=index.js.map